import { cn } from '@shared/utils/utils';
import { useTranslation } from 'react-i18next';
import type { RulesModel } from '../../models/Rules';
import { getRuleSummaryLines } from '../../utils/ruleListSummary';

interface RuleListSummaryProps {
  rule: RulesModel;
  className?: string;
}

/**
 * Resumen de condiciones y acciones para listas (no reemplaza el formulario de edición).
 */
export const RuleListSummary = ({ rule, className }: RuleListSummaryProps) => {
  const { t } = useTranslation('rulesModule');
  const { line1, line2 } = getRuleSummaryLines(rule, t);

  return (
    <div className={cn('text-xs text-muted-foreground space-y-0.5', className)} data-testid="rule-list-summary">
      <p className="line-clamp-2 leading-snug" title={line1}>
        {line1}
      </p>
      <p className="line-clamp-1 text-foreground/90 font-medium" title={line2}>
        {line2}
      </p>
    </div>
  );
};
